<template>
  <section class="app-main">
    <router-view v-slot="{ Component }" v-if='$route.meta.keepAlive'>
      <transition name="fade-transform" mode="out-in">
        <keep-alive >
          <component  :is="Component"/>
        </keep-alive>
      </transition>
    </router-view>
    <router-view v-else></router-view>
  </section>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {
    key () {
      return this.$route.fullPath
    }
  },
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
.app-main {
  width: 100%;
  height: 100%;
}
</style>
